import { createVNode } from "vue";
import * as $Icon from "@ant-design/icons-vue";

// 详情请看: https://segmentfault.com/a/1190000039673424

export const Icon = (props) => {
  const { icon } = props;
  return createVNode($Icon[icon]);
};
